import { useSearchParams } from 'react-router-dom';
import { CurrentOrPreviousGroup } from '../../../../../../api/groups';
import { useCallback, useMemo } from 'react';
import { useResultsDataContext } from '../../ResultsDataContext';
import { FilterSearchParam } from '../../../../../../shared-components/elementis/types/FilterSearchParam';

export function useSelectedSchool() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { groups } = useResultsDataContext();

  const selectedSchoolId = searchParams.get(FilterSearchParam.School);

  const selectedSchool = useMemo(() => {
    if (selectedSchoolId) {
      return groups.find(x => x.school.id === selectedSchoolId)?.school || null;
    }

    return null;
  }, [groups, selectedSchoolId]);

  const setSelectedSchool = useCallback(
    (school: CurrentOrPreviousGroup['school']) => {
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.set(FilterSearchParam.School, school.id);
        newParams.delete(FilterSearchParam.Groups);
        newParams.delete(FilterSearchParam.Members);

        return newParams;
      });
    },
    [setSearchParams],
  );

  return [selectedSchool, setSelectedSchool] as const;
}
